import React, { useState, useEffect } from "react";
import { Calendar, Clock, Users, X, AlertCircle } from "lucide-react";
import { Modal } from "react-bootstrap";
import "./careTeamStyle.css";
import { httpAdmin } from "../../../Apis/commonApis";
import swal from "sweetalert";
import { disablePastDate, getFullName } from "../../../utils/CommonFunctions";
import moment from "moment";

const defaultUserImg = "/admin/images/chatUser.svg";

const CareTeamReassignment = ({
  allCareTeam,
  openReassignment,
  closeopenReassignment,
  shedulerType,
}) => {
  // States for various selections and data
  const [selectedCaregiver, setSelectedCaregiver] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [availableCaregivers, setAvailableCaregivers] = useState([]);
  const [selectedNewCaregiver, setSelectedNewCaregiver] = useState(null);
  const [affectedShifts, setAffectedShifts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isCalculatingShifts, setIsCalculatingShifts] = useState(false);
  let currentCareSiteId = localStorage?.getItem("currentCareSiteId");
  let userData = JSON.parse(localStorage.getItem("userData"));
  // For sorting criteria management - only one active at a time
  const [activeSortCriterion, setActiveSortCriterion] = useState(
    "weeklyHoursAssigned"
  ); // Default is Weekly Hours
  const [availableCareMembers, setAvailableCareMembers] = useState([]);

  const caregivers = allCareTeam?.length
    ? allCareTeam?.map((item) => ({
        id: item?._id,
        name: getFullName(item),
        role: "Senior Caregive",
        avatar: item?.image,
      }))
    : [];

  // // Sample data
  // const caregivers = [
  //   { id: 1, name: 'Sarah Johnson', role: 'Senior Caregiver', avatar: '/api/placeholder/30/30' },
  //   { id: 2, name: 'Michael Chen', role: 'Caregiver', avatar: '/api/placeholder/30/30' },
  //   { id: 3, name: 'Emma Williams', role: 'Senior Caregiver', avatar: '/api/placeholder/30/30' },
  //   { id: 4, name: 'David Lee', role: 'Caregiver', avatar: '/api/placeholder/30/30' }
  // ];
  const [sampleShifts, setSampleShifts] = useState([]);

  const getCaregivers = async (
    careTeamId,
    startDateTime,
    endDateTime,
    sortType
  ) => {
    const sortCriteria = sortType ? sortType : activeSortCriterion;
    const endPointString = "getReassignDetails";
    let res = await httpAdmin(
      endPointString,
      "POST",
      {
        careTeamId: careTeamId?.id,
        careHomeId: currentCareSiteId,
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        priorityBasedOn: sortCriteria,
      },
      null
    );

    if (res?.status) {
      const affectedShiftsData = res?.data?.affectedShifts?.length
        ? res.data.affectedShifts.map((item) => ({
            id: item?._id,
            date: item?.globalShift?.Date,
            timeRange:
              item?.globalShift?.startingTime +
              "-" +
              item?.globalShift?.endingTime,
            clients: item?.clients?.map(
              (item) => `${item?.first_Name} ${item?.last_Name}`
            ),
          }))
        : [];

      const availableCareList = res.data?.availableCareteams?.map((item) => {
        return {
          id: item._id,
          name: getFullName(item),
          role: "Senior Caregive",
          avatar: item.image,
          matchPercent: 84,
          shiftsConflict: 0,
          weeklyHoursAssigned: item.totalHours ?? 0,
          distance: 17,
          rating: "4.3",
          performance: item.averagePerformance ?? 0,
          distance: item.distance ?? 0,
        };
      });
      const sorted =
        sortCriteria === "performance"
          ? sortArrayByKeyDesc(availableCareList, sortCriteria)
          : sortArrayByKeyAsc(availableCareList, sortCriteria);
      setAvailableCareMembers(sorted);
      setSampleShifts([...affectedShiftsData]);
    }
  };

  useEffect(() => {
    setAffectedShifts(sampleShifts);
  }, [sampleShifts]);

  function formatToISOString(date, time) {
    // Combine date and time into a single string
    const dateTimeString = `${date}T${time}:00.000Z`;

    // Convert to a Date object
    const dateObj = new Date(dateTimeString);

    // Ensure correct ISO format
    return dateObj.toISOString();
  }

  const handleCaregiverSelect = (caregiver) => {
    setSelectedCaregiver(caregiver);
    // Reset fields when changing caregiver
    setAffectedShifts([]);
    setAvailableCaregivers([]);
    setSelectedNewCaregiver(null);
  };

  const handleCheckShifts = (sortType) => {
    if (
      !selectedCaregiver ||
      !startDate ||
      !endDate ||
      !startTime ||
      !endTime
    ) {
      return;
    }
    setIsCalculatingShifts(true);

    const userData = JSON.parse(localStorage.getItem("userData"));
    const startFullDate = moment(
      `${startDate} ${startTime}`,
      "YYYY-MM-DD HH:mm:ss"
    )
      .tz(userData?.timeZone ?? "Asia/Calcutta")
      .format();
    // formatToISOString(startDate, startTime);
    const endFullDate = moment(`${endDate} ${endTime}`, "YYYY-MM-DD HH:mm:ss")
      .tz(userData?.timeZone ?? "Asia/Calcutta")
      .format();
    // formatToISOString(endDate, endTime);

    // Simulate API call with delay
    setTimeout(() => {
      getCaregivers(selectedCaregiver, startFullDate, endFullDate, sortType);
      setIsCalculatingShifts(false);
    }, 500);
  };

  // Function to sort caregivers based on the active criterion
  const sortCaregivers = (caregivers) => {
    if (!caregivers || caregivers.length === 0) return [];

    const sortedCaregivers = [...caregivers];

    if (activeSortCriterion === "weeklyHoursAssigned") {
      // Sort by weekly hours (ascending - least busy first)
      // sortedCaregivers.sort((a, b) => a.weeklyHours - b.weeklyHours);
      handleCheckShifts("weeklyHoursAssigned");
    } else if (activeSortCriterion === "distance") {
      // Sort by distance (ascending - closest first)
      // sortedCaregivers.sort((a, b) => a.distance - b.distance);
      handleCheckShifts("distance");
    } else if (activeSortCriterion === "performance") {
      // Sort by performance (descending - highest rated first)
      // sortedCaregivers.sort(
      //   (a, b) => parseFloat(b.rating) - parseFloat(a.rating)
      // );
      handleCheckShifts("performance");
    }

    return sortedCaregivers;
  };

  // Handle finding available caregivers
  const handleFindAvailable = () => {
    if (
      !selectedCaregiver ||
      !startDate ||
      !endDate ||
      !startTime ||
      !endTime ||
      affectedShifts.length === 0
    ) {
      return; // Validate that all fields are filled and shifts are found
    }

    setIsLoading(true);

    // Simulate API call delay
    setTimeout(() => {
      // Sample available caregivers (excluding selected caregiver)
      const available = caregivers
        .filter((c) => c.id !== selectedCaregiver.id)
        .map((c) => {
          // Generate random stats based on filters
          const weeklyHours = Math.floor(Math.random() * 40) + 5; // 5-45 hours
          const distance = Math.floor(Math.random() * 25) + 1; // 1-25 km
          const rating = Math.random() * 1.5 + 3.5; // 3.5-5.0 rating

          return {
            ...c,
            matchPercent: Math.floor(Math.random() * 30) + 70, // Random match percentage between 70-100%
            shiftsConflict: Math.floor(Math.random() * 2), // 0 or 1 conflicts
            weeklyHours,
            distance,
            rating: rating.toFixed(1),
          };
        });
      // Apply initial sort based on default criterion
      const sortedCaregivers = sortCaregivers(available);
      setAvailableCaregivers(sortedCaregivers);
      setIsLoading(false);
    }, 800);
  };

  // Apply sorting when criterion changes
  useEffect(() => {
    if (availableCaregivers.length > 0) {
      const sorted = sortCaregivers(availableCaregivers);
      setAvailableCaregivers(sorted);
    }
  }, [activeSortCriterion]);

  const handleNewCaregiverSelect = (caregiver) => {
    setSelectedNewCaregiver(caregiver);
  };

  const handleReassign = async () => {
    // Implementation for actual reassignment would go here
    const endPointString = "reassignCareteam";
    let res = await httpAdmin(
      endPointString,
      "POST",
      {
        shiftIds: sampleShifts?.length
          ? sampleShifts?.map((item) => item?.id)
          : [],
        careTeamId: selectedNewCaregiver?.id,
      },
      null
    )
      .then(function (response) {
        swal(
          response.status ? "Success" : "Failed",
          response.message,
          response.status ? "success" : "error"
        ).then((value) => {
          handleClose();
        });
      })
      .catch(function (error) {
        if (error.response) {
          swal("Failed", error.response.data.message, "error");
        } else if (error.request) {
          // console.log(error.request);
        } else {
          swal("Failed", error.message, "error");
        }
        // console.log(error.config);
      });
  };

  const handleClose = () => {
    closeopenReassignment();
  };

  // Handle changing the sort criterion
  const handleSortChange = (criterion) => {
    setActiveSortCriterion(criterion);
  };

  const selectedCareImg =
    selectedCaregiver?.avatar && selectedCaregiver?.avatar !== ""
      ? selectedCaregiver.avatar
      : defaultUserImg;

  return (
    <Modal size="lg" show={openReassignment} onHide={closeopenReassignment}>
      <Modal.Header closeButton>
        <h5 className="modal-title">Care Team Reassignment</h5>
      </Modal.Header>

      <Modal.Body className="care-team-reassignment-modal-body">
        {/* Step 1: Select Caregiver */}
        <div className="mb-6 reassign-box">
          <h5 className="form-label col-md-12" style={{ marginLeft: "5" }}>
            1. Select Care Team Member to Reassign From
          </h5>
          <div className="caregiver-selection-container">
            <div className="caregiver-selection-header">
              {selectedCaregiver ? (
                <>
                  <div className="me-2">
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        // marginBottom: "4px",
                      }}
                      src={selectedCareImg}
                      alt={selectedCaregiver.name}
                      className={
                        selectedCareImg.includes("chatUser")
                          ? "forImagecareteam"
                          : ""
                      }
                    />
                  </div>
                  <div>
                    <div className="caregiver-name">
                      {selectedCaregiver.name}
                    </div>
                    <div className="caregiver-role">
                      {selectedCaregiver.role}
                    </div>
                  </div>
                </>
              ) : (
                <div className="caregiver-placeholder">
                  Select a care team member
                </div>
              )}
            </div>
            <select
              className="caregiver-select"
              onChange={(e) => {
                if (e.target.value) {
                  const selectedId = e.target.value;
                  const selected = caregivers.find((c) => c.id === selectedId);
                  handleCaregiverSelect(selected);
                }
              }}
              value={selectedCaregiver?.id || ""}
            >
              <option value="">Select a care team member</option>
              {caregivers.map((caregiver) => (
                <option key={caregiver.id} value={caregiver.id}>
                  {caregiver.name} - {caregiver.role}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Step 2: Select Date and Time Range */}
        {selectedCaregiver && (
          <div className="mb-6">
            <h5 className="form-label col-md-4">
              2. Select Date and Time Range
            </h5>
            <div className="date-time-grid">
              <div className="date-time-item">
                <label className="form-label">Start Date</label>
                <div className="input-container">
                  {/* <div className="input-icon">
                    <Calendar size={16} className="text-gray-500" />
                  </div> */}
                  <input
                    type="date"
                    min={disablePastDate()}
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      setEndDate("");
                    }}
                    className="form-input"
                  />
                </div>
              </div>
              <div className="date-time-item">
                <label className="form-label">End Date</label>
                <div className="input-container">
                  {/* <div className="input-icon">
                    <Calendar size={16} className="text-gray-500" />
                  </div> */}
                  <input
                    type="date"
                    value={endDate}
                    min={disablePastDate(startDate)}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-input"
                  />
                </div>
              </div>
              <div className="date-time-item">
                <label className="form-label ">Start Time (24h)</label>
                <div className="input-container">
                  {/* <div className="input-icon">
                    <Clock size={16} className="text-gray-500" />
                  </div> */}
                  <select
                    value={startTime}
                    onChange={(e) => {
                      setStartTime(e.target.value);
                      setEndTime("");
                    }}
                    className="form-select"
                  >
                    <option value="">Select time</option>
                    {Array.from({ length: 24 * 4 }, (_, i) => {
                      const hour = Math.floor(i / 4);
                      const minute = (i % 4) * 15;
                      return `${hour.toString().padStart(2, "0")}:${minute
                        .toString()
                        .padStart(2, "0")}`;
                    }).map((time) => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="date-time-item">
                <label className="form-label">End Time (24h)</label>
                <div className="input-container">
                  {/* <div className="input-icon">
                    <Clock size={16} className="text-gray-500" />
                  </div> */}
                  <select
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    className="form-select"
                    disabled={!startTime}
                  >
                    <option value="" className="form-select-option">
                      Select time
                    </option>
                    {Array.from({ length: 24 * 4 }, (_, i) => {
                      const hour = Math.floor(i / 4);
                      const minute = (i % 4) * 15;
                      const currentTime = `${hour
                        .toString()
                        .padStart(2, "0")}:${minute
                        .toString()
                        .padStart(2, "0")}`;
                      const isDisabled =
                        startTime &&
                        new Date(`1970-01-01T${currentTime}:00Z`) <=
                          new Date(`1970-01-01T${startTime}:00Z`);

                      return (
                        <option
                          key={currentTime}
                          value={currentTime}
                          disabled={isDisabled}
                        >
                          {currentTime}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>

            <div className="mt-4 mb-6">
              <button
                onClick={() => handleCheckShifts()}
                disabled={
                  !startDate ||
                  !endDate ||
                  !startTime ||
                  !endTime ||
                  isCalculatingShifts
                }
                className={` ${
                  !startDate ||
                  !endDate ||
                  !startTime ||
                  !endTime ||
                  isCalculatingShifts
                    ? "action-button-disabled submit_b task_btn_size "
                    : "submit_b task_btn_size"
                }`}
              >
                {isCalculatingShifts ? "Checking..." : "Check Affected Shifts"}
              </button>
            </div>

            {/* Step 3: Affected Shifts */}
            <div className="mt-2 mb-6">
              <h5 className="form-label col-md-4">
                3. Affected Shifts{" "}
                {affectedShifts.length > 0 && `(${affectedShifts.length})`}
              </h5>

              {isCalculatingShifts ? (
                <div className="shifts-container">
                  <p className="text-gray-500 mb-2">
                    Calculating affected shifts...
                  </p>
                </div>
              ) : affectedShifts.length > 0 ? (
                <div className="shifts-table-container">
                  <table className="shifts-table">
                    <thead className="shifts-table-header">
                      <tr>
                        <th className="shifts-table-header-cell">Date</th>
                        <th className="shifts-table-header-cell">Time</th>
                        <th className="shifts-table-header-cell">Clients</th>
                      </tr>
                    </thead>
                    <tbody className="shifts-table-body">
                      {affectedShifts.map((shift) => (
                        <tr key={shift.id}>
                          <td className="shifts-table-body-cell">
                            {shift.date}
                          </td>
                          <td className="shifts-table-body-cell">
                            {shift.timeRange}
                          </td>
                          <td className="shifts-table-body-cell">
                            {shift.clients.join(", ")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="no-shifts-container">
                  <p className="no-shifts-text">
                    {selectedCaregiver &&
                    startDate &&
                    endDate &&
                    startTime &&
                    endTime
                      ? 'Click "Check Affected Shifts" to see shifts that will be reassigned'
                      : "Complete all date and time fields to continue"}
                  </p>
                </div>
              )}
            </div>

            <div className="mt-4">
              <button
                onClick={handleFindAvailable}
                disabled={
                  !startDate ||
                  !endDate ||
                  !startTime ||
                  !endTime ||
                  isLoading ||
                  affectedShifts.length === 0
                }
                className={`${
                  !startDate ||
                  !endDate ||
                  !startTime ||
                  !endTime ||
                  isLoading ||
                  affectedShifts.length === 0
                    ? "action-button-disabled submit_b task_btn_size"
                    : "submit_b task_btn_size"
                }`}
              >
                {isLoading ? "Finding..." : "Find Available Caregivers"}
              </button>
            </div>
          </div>
        )}

        {/* Step 4: Available Caregivers */}
        {availableCaregivers.length > 0 && (
          <div>
            <h5 className="form-label col-md-4 ">
              4. Select New Care Team Member
            </h5>

            <div className="mb-4">
              <div className="sort-options-container">
                <span className="sort-label">Sort by:</span>

                <button
                  type="button"
                  onClick={() => handleSortChange("weeklyHoursAssigned")}
                  className={`sort-button ${
                    activeSortCriterion === "weeklyHoursAssigned"
                      ? "sort-button-active"
                      : ""
                  }`}
                >
                  Weekly Hours
                </button>

                {shedulerType === "facility" && (
                  <button
                    type="button"
                    onClick={() => handleSortChange("distance")}
                    className={`sort-button ${
                      activeSortCriterion === "distance"
                        ? "sort-button-active"
                        : ""
                    }`}
                  >
                    Distance
                  </button>
                )}

                <button
                  type="button"
                  onClick={() => handleSortChange("performance")}
                  className={`sort-button ${
                    activeSortCriterion === "performance"
                      ? "sort-button-active"
                      : ""
                  }`}
                >
                  Performance
                </button>
              </div>
            </div>

            <div className="available-caregivers-grid">
              {availableCareMembers?.length > 0 &&
                availableCareMembers.map((caregiver) => {
                  const caregiverImg =
                    caregiver?.avatar && caregiver?.avatar !== ""
                      ? caregiver.avatar
                      : defaultUserImg;
                  return (
                    <div
                      key={caregiver.id}
                      className={`caregiver-card ${
                        selectedNewCaregiver?.id === caregiver.id
                          ? "caregiver-card-selected"
                          : ""
                      }`}
                      onClick={() => handleNewCaregiverSelect(caregiver)}
                    >
                      <div className="caregiver-card-content">
                        <div className="caregiver-info">
                          <div className="me-2">
                            <img
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                objectFit: 'cover'
                                // marginBottom: "4px",
                              }}
                              src={caregiverImg}
                              alt={caregiver.name}
                              className={
                                caregiverImg.includes("chatUser")
                                  ? "forImagecareteam"
                                  : ""
                              }
                            />
                          </div>
                          <div>
                            <div className="caregiver-name">
                              {caregiver.name}
                            </div>
                            <div className="caregiver-role">
                              {caregiver.role}
                            </div>
                            <div className="caregiver-stats">
                              {activeSortCriterion === "performance" && (
                                <span className="caregiver-stat">
                                  Performance:{" "}
                                  {caregiver.performance?.toFixed(2)} %
                                </span>
                              )}
                              {activeSortCriterion ===
                                "weeklyHoursAssigned" && (
                                <span className="caregiver-stat">
                                  Weekly Hours:{" "}
                                  {caregiver.weeklyHoursAssigned?.toFixed(2)}{" "}
                                  Hrs
                                </span>
                              )}
                              {activeSortCriterion === "distance" && (
                                <span className="caregiver-stat">
                                  Weekly Hours: {caregiver.distance?.toFixed(2)}{" "}
                                  miles
                                </span>
                              )}
                              {/* <span className="caregiver-stat">
                            <svg
                              className="star-icon"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                            {caregiver.rating}
                          </span> */}
                            </div>
                          </div>
                        </div>

                        {/* <div className="caregiver-card-actions">
                      {caregiver.shiftsConflict > 0 && (
                        <div className="conflicts-warning">
                          <AlertCircle size={16} className="conflicts-icon" />
                          <span className="conflicts-text">
                            {caregiver.shiftsConflict} conflicts
                          </span>
                        </div>
                      )}
                      <div className="match-percentage">
                        {caregiver.matchPercent}% match
                      </div>
                    </div> */}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          className="submit_b task_btn_size"
          onClick={closeopenReassignment}
        >
          Cancel
        </button>
        <button
          className={`submit_b task_btn_size ${
            !selectedNewCaregiver
              ? "action-button-disabled"
              : "action-button-primary"
          }`}
          disabled={!selectedNewCaregiver}
          onClick={handleReassign}
        >
          Reassign
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CareTeamReassignment;

const sortArrayByKeyAsc = (arr, key) => {
  return [...arr].sort((a, b) => {
    const valA = Number(a[key]);
    const valB = Number(b[key]);
    return valA - valB;
  });
};
const sortArrayByKeyDesc = (arr, key) => {
  return [...arr].sort((a, b) => {
    const valA = Number(a[key]);
    const valB = Number(b[key]);
    return valB - valA;
  });
};
